import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { syncCheckout, getAccountDetail, getPlans } from '../../Redux/ActionCreators/settingAction';

const RETRY_DELAYS = [2000, 5000, 10000, 12000, 15000];

export default function BillingSuccess() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading'); // loading | success | error
    const calledRef = useRef(false);

    useEffect(() => {
        if (calledRef.current) return;
        calledRef.current = true;

        const attemptSync = async (orderId, attempt) => {
            try {
                const res = await Promise.resolve(dispatch(syncCheckout(orderId)));
                const data = res?.payload?.data;
                const paymentStatus = data?.status;
                // const paypalSubscriptionStatus = data?.gateway_snapshot?.paypal?.subscription_status;

                const isSuccess = paymentStatus === 'paid'

                if (!isSuccess && paymentStatus === 'pending' && attempt < RETRY_DELAYS.length) {
                    setTimeout(() => attemptSync(orderId, attempt + 1), RETRY_DELAYS[attempt]);
                    return;
                }

                if (isSuccess) {
                    await Promise.resolve(dispatch(getAccountDetail()));
                    await Promise.resolve(dispatch(getPlans()));
                    localStorage.removeItem('payment_order_id');
                    setStatus('success');
                } else {
                    setStatus('error');
                }
            } catch {
                setStatus('error');
            }

            setTimeout(() => { navigate('/plan'); }, 3000);
        };

        const orderId = localStorage.getItem('payment_order_id');
        if (!orderId) {
            setStatus('error');
            setTimeout(() => { navigate('/plan'); }, 5000);
            return;
        }

        attemptSync(orderId, 0);
    }, [dispatch, navigate]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f8f9fa', fontFamily: '"Inter", "Segoe UI", Roboto, sans-serif' }}>
            <style>
                {`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                @keyframes pulse {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.05); }
                    100% { transform: scale(1); }
                }
                `}
            </style>

            <div style={{ backgroundColor: '#ffffff', padding: '40px 32px', borderRadius: '16px', boxShadow: '0 10px 25px rgba(0,0,0,0.05)', textAlign: 'center', maxWidth: '400px', width: '90%' }}>
                {status === 'loading' && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
                        <div style={{ width: '60px', height: '60px', border: '6px solid rgba(247, 88, 145, 0.2)', borderTop: '6px solid #F75891', borderRadius: '50%', animation: 'spin 1s linear infinite', marginBottom: '12px' }}></div>
                        <h2 style={{ margin: '0', fontSize: '24px', color: '#2d3436', fontWeight: '600' }}>Verifying Payment</h2>
                        <p style={{ margin: '0', color: '#636e72', fontSize: '15px', lineHeight: '1.5' }}>Please wait while we confirm your transaction securely...</p>
                    </div>
                )}

                {status === 'success' && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
                        <i className="fas fa-check-circle" style={{ fontSize: '64px', marginBottom: '8px', color: '#F75891', animation: 'pulse 2s infinite' }} />
                        <h2 style={{ margin: '0', fontSize: '24px', color: '#2d3436', fontWeight: '600' }}>Payment Successful!</h2>
                        <p style={{ margin: '0', color: '#636e72', fontSize: '15px', lineHeight: '1.5' }}>Thank you for your purchase. We are redirecting you to your plans.</p>
                    </div>
                )}

                {status === 'error' && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
                        <i className="fas fa-exclamation-circle" style={{ fontSize: '64px', marginBottom: '8px', color: '#e74c3c' }} />
                        <h2 style={{ margin: '0', fontSize: '24px', color: '#2d3436', fontWeight: '600' }}>Verification Failed</h2>
                        <p style={{ margin: '0', color: '#636e72', fontSize: '15px', lineHeight: '1.5' }}>Something went wrong while verifying your payment. Redirecting back...</p>
                    </div>
                )}
            </div>
        </div>
    );
}